import { t } from '@/utils/i18n'
import { Container } from '@/components/ui/Container'
import { Gradients } from '@/utils/styles'
import { trackEvent } from '@/utils/analytics'
import { ContactForm } from '@/components/ui/ContactForm'

export function FinalCTASection(): HTMLElement {
  const section = document.createElement('section')
  section.className = `relative py-20 ${Gradients.brandDiagonal} overflow-hidden`

  const container = Container({
    children: [
      createCTAContent(),
    ],
    className: 'relative z-10',
  })

  section.appendChild(container)
  return section
}

function createCTAContent(): HTMLElement {
  const content = document.createElement('div')
  content.className = 'max-w-4xl mx-auto text-center'

  // Headline
  const headline = document.createElement('h2')
  headline.textContent = t('finalCta.headline')
  headline.className = 'text-4xl sm:text-5xl font-bold text-white mb-6'

  // Subheadline
  const subheadline = document.createElement('p')
  subheadline.textContent = t('finalCta.subheadline')
  subheadline.className = 'text-xl text-white/90 mb-10'

  // CTA Buttons
  const buttonContainer = document.createElement('div')
  buttonContainer.className = 'flex flex-col sm:flex-row gap-4 justify-center mb-16'

  const contactButton = document.createElement('a')
  contactButton.href = '/contact'
  contactButton.textContent = t('finalCta.ctaSecondary')
  contactButton.className = 'px-8 py-4 bg-white text-orange-600 font-bold rounded-lg hover:bg-slate-50 transition-all duration-300 hover:scale-105 shadow-lg'
  contactButton.addEventListener('click', (e) => {
    e.preventDefault()
    trackEvent('cta_click', { cta_location: 'final_cta_section', cta_label: 'contact' })
    window.dispatchEvent(new CustomEvent('navigate', { detail: '/contact' }))
  })

  buttonContainer.appendChild(contactButton)

  // Contact Form
  const formContainer = createContactForm()

  content.appendChild(headline)
  content.appendChild(subheadline)
  content.appendChild(buttonContainer)
  content.appendChild(formContainer)

  return content
}

function createContactForm(): HTMLElement {
  // Render the shared, backend-wired contact form (same fields + submit logic
  // + generate_lead tracking as the /contact page) inside a light card so it
  // reads well on the brand gradient. Single source of truth: ContactForm.
  const container = document.createElement('div')
  container.className = 'max-w-2xl mx-auto bg-white p-8 rounded-2xl shadow-xl text-left'

  const formTitle = document.createElement('h3')
  formTitle.textContent = t('contactForm.title')
  formTitle.className = 'text-2xl font-bold text-slate-900 mb-6 text-center'

  container.appendChild(formTitle)
  container.appendChild(ContactForm())

  return container
}
